<template>
  <div>
    <!-- 列表开始 -->
    <div class="BlockList">
      <div class="BlockList-W">
        <div class="Basic_tit">Token Update Application Form</div>
        <el-form ref="form" :model="form" :rules="rules">
          <div class="Basic_box">
            <div class="Infoleft">
              <div class="Infotit">Basic Information</div>
              <div class="Infotit1">
                Kindly check that all the links provided are working and
                <br />are safe to visit before submitting.
              </div>
            </div>
            <div class="Inforight">
              <div class="putext">
                <div class="puttit">
                  Token Contract Address<img src="@/assets/pc/Logo/xin.png" />
                </div>
                <el-form-item prop="contractAddress">
                  <el-input
                    v-model="form.contractAddress"
                    class="inpttext"
                    placeholder=""
                    :readonly="true"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="putext">
                <div class="puttit">
                  Link to download a 32x32 png icon logo<img
                    src="@/assets/pc/Logo/xin.png"
                  />
                </div>
                <el-form-item prop="logo">
                  <el-input
                    v-model="form.logo"
                    class="inpttext"
                    placeholder=""
                  ></el-input>
                  <div class="puttit1">
                    Image should be a PNG file with a resolution of 32x32
                  </div>
                </el-form-item>
              </div>
              <div class="putexta">
                <div class="putbox">
                  <div class="putboxtit">
                    Token Name<img src="@/assets/pc/Logo/xin.png" />
                  </div>
                  <el-form-item prop="contractName">
                    <el-input
                      v-model="form.contractName"
                      class="inpttext"
                      placeholder=""
                    ></el-input>
                    <div class="putboxcon">Please set your Token Name</div>
                  </el-form-item>
                </div>
                <div class="putbox">
                  <div class="putboxtit">
                    Token Symbol<img src="@/assets/pc/Logo/xin.png" />
                  </div>
                  <el-form-item prop="symbol">
                    <el-input
                      v-model="form.symbol"
                      class="inpttext"
                      placeholder=""
                    ></el-input>
                    <div class="putboxcon">Pease set your Token Symbol</div>
                  </el-form-item>
                </div>
              </div>
              <div class="putextb">
                <div class="puttit">
                  Project Description (Max 300 characters)<img
                    src="@/assets/pc/Logo/xin.png"
                  />
                </div>
                <el-form-item prop="projectDescription">
                  <el-input
                    type="textarea"
                    v-model="form.projectDescription"
                    class="inpttext"
                    placeholder=""
                  ></el-input>
                  <div class="puttit1">
                    Briefy encapsulate,introduce or summarise the project's
                    operation/mechanism/goals in a maximum of <br />300
                    characters. The short description should be written in a
                    neutral point of view and must exclude<br />
                    unsubstantiated claims ( "first"," most"," best",and etc)
                    unless proven otherwise.
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="Basic_boxa">
            <div class="Infoleft">
              <div class="Infotit">Social Profiles</div>
              <div class="Infotit1">
                Kindly provide us with the links to your official social<br />
                media pages on these platforms. These are usually the<br />
                secondary channels which users may use to contact<br />
                your team.
              </div>
            </div>
            <div class="Inforighta">
              <div class="socialbox">
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/1a.png" />
                  <div class="line"></div>
                  <el-form-item prop="officialWebSite">
                    <el-input
                      v-model.trim="form.officialWebSite"
                      class="inpttext"
                      placeholder="Official  Website"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/1.png" />
                  <div class="line"></div>
                  <el-form-item prop="whitepapper">
                    <el-input
                      v-model.trim="form.whitepapper"
                      class="inpttext"
                      placeholder="Whitepaper"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/2.png" />
                  <div class="line"></div>
                  <el-form-item prop="medium">
                    <el-input
                      v-model.trim="form.medium"
                      class="inpttext"
                      placeholder="Medium"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/3.png" />
                  <div class="line"></div>
                  <el-form-item prop="github">
                    <el-input
                      v-model.trim="form.github"
                      class="inpttext"
                      placeholder="GitHub"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/4.png" />
                  <div class="line"></div>
                  <el-form-item prop="reddit">
                    <el-input
                      v-model.trim="form.reddit"
                      class="inpttext"
                      placeholder="Reddit"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/5.png" />
                  <div class="line"></div>
                  <el-form-item prop="telegram">
                    <el-input
                      v-model.trim="form.telegram"
                      class="inpttext"
                      placeholder="Telegram"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/6.png" />
                  <div class="line"></div>
                  <el-form-item prop="facebook">
                    <el-input
                      v-model.trim="form.facebook"
                      class="inpttext"
                      placeholder="Facebook"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/7.png" />
                  <div class="line"></div>
                  <el-form-item prop="linkedin">
                    <el-input
                      v-model.trim="form.linkedin"
                      class="inpttext"
                      placeholder="Linkedin"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/8.png" />
                  <div class="line"></div>
                  <el-form-item prop="twitter">
                    <el-input
                      v-model.trim="form.twitter"
                      class="inpttext"
                      placeholder="Twitter"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/9.png" />
                  <div class="line"></div>
                  <el-form-item prop="discord">
                    <el-input
                      v-model.trim="form.discord"
                      class="inpttext"
                      placeholder="Discord"
                    ></el-input>
                  </el-form-item>
                </div>

                <div class="socialboxli">
                  <img src="../../../assets/pc/Logo/10.png" />
                  <div class="line"></div>
                  <el-form-item prop="opensea">
                    <el-input
                      v-model.trim="form.opensea"
                      class="inpttext"
                      placeholder="Opensea"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="button" @click="updateInfo">submit</div>
        </el-form>
      </div>
      <!-- 提交成功后进行返回 -->

      <div class="BlockListws" v-show="flog">
        <div class="box">
          <div class="tit1">Congratulations!</div>
          <div class="tit2">
            Your contract information has been successfully modified.
          </div>
          <div class="button" @click="black">OK</div>
        </div>
      </div>

      <!-- 提交成功后进行返回 -->
    </div>
    <!-- 列表结束 -->
  </div>
</template>

<script>
import axios from "axios";
import { GetBlockList } from "@/assets/server/api";
export default {
  data() {
    return {
      flog: false,
      url: "https://explorer.tfsc.io/tfscBrowser/user/",
      //url: "http://192.168.1.123:9200/tfscBrowser/user/",
      form: {
        contractAddress: "",
        logo: "",
        contractName: "",
        symbol: "",
        projectDescription: "",
        userId: "",
        opensea: "",
        github: "",
        twitter: "",
        discord: "",
        facebook: "",
        reddit: "",
        officialWebSite: "",
        whitepapper: "",
        telegram: "",
        medium: "",
        linkedin: "",
        socialProfiles: "",
      },
      rules: {
        contractAddress: [
          {
            required: true,
            message: "contractAddress  is required",
            trigger: "change",
          },
        ],
        logo: [
          {
            required: true,
            message: "logo  is required",
            trigger: "change",
          },
        ],
        contractName: [
          {
            required: true,
            message: "contractName  is required",
            trigger: "change",
          },
        ],
        symbol: [
          {
            required: true,
            message: "symbol  is required",
            trigger: "change",
          },
        ],
        projectDescription: [
          {
            required: true,
            message: "projectDescription  is required",
            trigger: "change",
          },
          {
            min: 0,
            max: 300,
            message: "Length less than 300",
            trigger: "blur",
          },
        ],
      },
      // userId: "",
      // contractAddress: "",
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.BlockList();
    this.jwtToken = localStorage.getItem("jwtToken");
    
    this.ContractInfo();
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/pc/Information") {
          this.form.contractAddress = to.query.contractAddress;
          this.form.userId = to.query.userId;
          // console.log(this.form.contractAddress);
          // console.log(this.userId);
          //   console.log(this.tokenId);

          //  console.log(this.contractAddress);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    search() {},
    //初始化合约信息
    ContractInfo() {
      const params = {
        userId: this.form.userId,
        contractAddress: this.form.contractAddress,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let config = {
        headers: {
          "Content-Type": "application/json",
          jwtToken: this.jwtToken,
        },
      }; //修改请求头
     // console.log(formData);

      // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
      let url = this.url + "getContractInfo";
      axios
        .post(url, formData, config)
        .then((res) => {
        //  console.log(res.data.result);
          if (res.data.code == 200) {
         //   console.log("第二部签名开始");
            //       form: {
            //  contractAddress:'',
            //  logo: '',
            //  contractName: '',
            //  symbol: '',
            //  projectDescription: '',
            //  userId:''
            // },
            this.form.logo = res.data.result.logo;
            this.form.contractName = res.data.result.contractName;
           // console.log(this.form.contractName);
            this.form.symbol = res.data.result.symbol;
          //  console.log(this.form.symbol);
            this.form.projectDescription = res.data.result.projectDescription;
          //  console.log(this.form.projectDescription);

            if (res.data.result.socialProfiles !== "") {
              this.socialProfiles = JSON.parse(res.data.result.socialProfiles);
         //     console.log(this.socialProfiles);
              this.form.opensea = this.socialProfiles.opensea;
              this.form.github = this.socialProfiles.github;
        //      console.log(this.form.github);
              this.form.twitter = this.socialProfiles.twitter;
              this.form.discord = this.socialProfiles.discord;
              this.form.facebook = this.socialProfiles.facebook;
              this.form.reddit = this.socialProfiles.reddit;
              this.form.whitepapper = this.socialProfiles.whitepapper;
              this.form.telegram = this.socialProfiles.telegram;
              this.form.medium = this.socialProfiles.medium;
              this.form.linkedin = this.socialProfiles.linkedin;
              this.form.officialWebSite = this.socialProfiles.officialWebSite;
            }

            //     opensea: "",
            // github: "",
            // twitter: "",
            // discord: "",
            // facebook: "",
            // reddit: "",
            // whitepapper: "",
            // telegram: "",
            // medium: "",
            // linkedin: "",
          } else if (res.data.code == 401) {
           // this.$message("Please log in again999");
            this.$router.push("/pc/Index");
          //  console.log("进行了异地登录1111");

            localStorage.removeItem("userId");
            localStorage.removeItem("email");
            localStorage.removeItem("jwtToken"); //  this.$message(res.data.result);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
         // console.log(err);
        });
    },
    updateInfo() {
      this.$refs.form.validate(async (success) => {
        //    if (this.validatePassword()) {
     //   console.log(this.form);
        if (success) {
          const urlPattern = /^(http|https):\/\/[^ "]+$/;
          if (urlPattern.test(this.form.logo)) {
            // console.log("Please enter an HTTP connection");
            // 在这里执行与是HTTP链接相关的操作

            if (this.form.officialWebSite !== "") {
              if (!urlPattern.test(this.form.officialWebSite)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the officialWebSite"
                );
                return false;
              }
            }
            if (this.form.opensea !== "") {
              if (!urlPattern.test(this.form.opensea)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the opensea"
                );
                return false;
              }
            }
            if (this.form.github !== "") {
              if (!urlPattern.test(this.form.github)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the github"
                );
                return false;
              }
            }
            if (this.form.twitter !== "") {
              if (!urlPattern.test(this.form.twitter)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the twitter"
                );
                return false;
              }
            }
            if (this.form.discord !== "") {
              if (!urlPattern.test(this.form.discord)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the discord"
                );
                return false;
              }
            }
            if (this.form.facebook !== "") {
              if (!urlPattern.test(this.form.facebook)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the facebook"
                );
                return false;
              }
            }
            if (this.form.reddit !== "") {
              if (!urlPattern.test(this.form.reddit)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the reddit"
                );
                return false;
              }
            }
            if (this.form.whitepapper !== "") {
              if (!urlPattern.test(this.form.whitepapper)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the whitepapper"
                );
                return false;
              }
            }
            if (this.form.telegram !== "") {
              if (!urlPattern.test(this.form.telegram)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the telegram"
                );
                return false;
              }
            }
            if (this.form.medium !== "") {
              if (!urlPattern.test(this.form.medium)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the medium"
                );
                return false;
              }
            }
            if (this.form.linkedin !== "") {
              if (!urlPattern.test(this.form.linkedin)) {
                this.$message(
                  "Please enter an HTTP/HTTPS connection in the linkedin"
                );
                return false;
              }
            }
            // if(this.form.opensea!==""){
            //     if(!urlPattern.test(this.form.opensea)){
            //       this.$message("Please enter an HTTP connection in the opensea");
            //       return false;
            //     }
            // }

            const params = {
              symbol: this.form.symbol,
              userId: this.form.userId,
              contractAddress: this.form.contractAddress,
              projectDescription: this.form.projectDescription,
              logo: this.form.logo,
              contractName: this.form.contractName,
              opensea: this.form.opensea,
              github: this.form.github,
              twitter: this.form.twitter,
              discord: this.form.discord,
              facebook: this.form.facebook,
              reddit: this.form.reddit,
              whitepapper: this.form.whitepapper,
              telegram: this.form.telegram,
              medium: this.form.medium,
              linkedin: this.form.linkedin,
              officialWebSite: this.form.officialWebSite,
            };
          //  console.log(params);
            const formData = new FormData();
            const item = params;
            for (const key in item) {
              if (Object.hasOwnProperty.call(item, key)) {
                formData.append(key, item[key]);
              }
            }
          //  console.log(formData);
            let config = {
              headers: {
                "Content-Type": "application/json",
                jwtToken: this.jwtToken,
              },
            }; //修改请求头 // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";

            let url = this.url + "updateContractInfo";
            axios
              .post(url, params, config)
              .then((res) => {
             //   console.log(res.data.result);
                if (res.data.code == 200) {
              //    console.log("第二部签名开始"); //       form: { //  contractAddress:'', //  logo: '', //  contractName: '', //  symbol: '', //  projectDescription: '', //  userId:'' // },
                  // this.$message("Modified successfully");
                  this.flog = true;
                } else if (res.data.code == 401) {
               //   console.log("进行了异地登录1111");

                  localStorage.removeItem("userId");
                  localStorage.removeItem("email");
                  localStorage.removeItem("jwtToken"); //  this.$message(res.data.result);
                  //  this.signout();
                  this.$message("Please log in again");
                }
              })
              .catch((err) => {
                this.$message.error(err.message);
            //    console.log(err);
              });
          } else {
            //console.log("不是HTTP链接");
            this.$message("Please enter an HTTP connection in the logo");
            return false;
            // 在这里执行与不是HTTP链接相关的操作
          }
        } else {
          // this.$message(" This field are not filled in ");
          return false;
        }
      });
    },
    black() {
      this.$router.push("/pc/Ownership");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.BlockList {
  width: 100%;
  background: #13161b;
  position: relative;
  .BlockList-W {
    width: 1180px;
    margin: 0 auto;
    padding-bottom: 36px;
    background: #13161b;
    .Basic_tit {
      height: 27px;
      font-size: 23px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #ffffff;
      line-height: 27px;
      margin-top: 10px;
    }
    .Basic_box {
      margin-top: 25px;
      width: 1160px;
      // height: 1214px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      display: flex;
      justify-content: space-between;
      // margin:0px 40px;
      padding-top: 26px;
      .Infoleft {
        margin-left: 40px;
        .Infotit {
          height: 25px;
          font-size: 21px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #ffffff;
          line-height: 25px;
        }
        .Infotit1 {
          height: 36px;
          font-size: 14px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          line-height: 18px;
          margin-top: 10px;
          word-spacing: -2px;
        }
      }
      .Inforight {
        // margin-right: 40px;
        .putext {
          .puttit {
            height: 18px;
            font-size: 15px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #ffffff;
            line-height: 18px;
            img {
              width: 9px;
              height: 10px;
              margin-top: 4px;
              margin-left: 4px;
            }
          }

          /deep/.el-input__inner {
            width: 660px;
            height: 48px;
            border: none;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            margin-top: 12px;
            color: #fff;
          }

          /deep/.el-input__inner::placeholder {
            color: rgba(255, 255, 255, 0.5);
          }
          /deep/.el-input__inner:hover {
            width: 660px;
            height: 48px;
            background: #000000;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            border: 2px solid rgba(0, 226, 152, 0.5);
          }
          .puttit1 {
            height: 18px;
            font-size: 14px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #898b8d;
            line-height: 18px;
            margin-top: 10px;
          }
        }
        .putexta {
          display: flex;
          .putbox {
            width: 314px;
            margin-right: 32px;
            .putboxtit {
              height: 18px;
              font-size: 15px;
              font-family: Roboto, Roboto;
              font-weight: 500;
              color: #ffffff;
              line-height: 18px;
              img {
                width: 9px;
                height: 10px;
                margin-top: 4px;
                margin-left: 4px;
              }
            }
            /deep/.el-input__inner {
              width: 314px;
              height: 48px;
              background: #13161b;
              border-radius: 10px 10px 10px 10px;
              opacity: 1;
              border: none;
              color: #fff;
              margin-top: 12px;
            }

            /deep/.el-input__inner::placeholder {
              color: rgba(255, 255, 255, 0.5);
            }
            .putboxcon {
              height: 18px;
              font-size: 14px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #898b8d;
              line-height: 18px;
              margin-top: 10px;
            }
          }
        }
        .putextb {
          .puttit {
            height: 18px;
            font-size: 15px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #ffffff;
            line-height: 18px;
            img {
              width: 9px;
              height: 10px;
              margin-top: 4px;
              margin-left: 4px;
            }
          }
          /deep/.el-textarea__inner {
            height: 166px;
            width: 660px;
            border: none;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            margin-top: 12px;
            color: #fff;
          }

          /deep/.el-input__inner::placeholder {
            color: rgba(255, 255, 255, 0.5);
          }
          /deep/.el-textarea__inner:hover {
            height: 166px;
            width: 660px;
            background: #000000;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            border: 2px solid rgba(0, 226, 152, 0.5);
          }
          /deep/.el-input__inner {
            width: 660px;
            height: 166px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            border: none;
            margin-top: 12px;
            color: #fff;
          }
          /deep/.el-input__inner:hover {
            width: 660px;
            height: 166px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            border: 2px solid rgba(0, 226, 152, 0.5);
            margin-top: 12px;
          }
          .puttit1 {
            height: 54px;
            font-size: 14px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #898b8d;
            line-height: 18px;
            margin-top: 10px;
            // padding-bottom: 20px;
          }
        }
      }
    }
    .Basic_boxa {
      margin-top: 25px;
      width: 1160px;
      // height: 1214px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      display: flex;
      justify-content: space-between;

      // margin:0px 40px;
      padding-top: 26px;
      .Infoleft {
        margin-left: 40px;
        .Infotit {
          height: 25px;
          font-size: 21px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #ffffff;
          line-height: 25px;
        }
        .Infotit1 {
          height: 36px;
          font-size: 14px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          line-height: 18px;
          margin-top: 10px;
          word-spacing: -2px;
        }
      }
      .Inforighta {
        width: 660px;
        //border: 1px solid red;
        margin-right: 40px;
        .socialbox {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .socialboxli {
            display: flex;

            width: 314px;
            height: 48px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            margin-bottom: 30px;
            img {
              width: 26px;
              height: 26px;
              margin-left: 15px;
              margin-top: 11px;
            }
            .line {
              width: 1px;
              height: 32px;
              opacity: 1;
              border: 1px solid rgba(137, 139, 141, 0.5);
              margin-left: 15px;
              margin-top: 8px;
            }

            /deep/.el-input__inner::placeholder {
              color: rgba(255, 255, 255, 0.5);
            }
            /deep/.el-input__inner {
              margin-left: 15px;
              margin-top: 4px;
              width: 238px;
              // height: 48px;
              opacity: 1;
              background: #13161b;
              border: none;
              color: #fff;
            }
          }
        }
      }
    }
    .button {
      width: 305px;
      height: 54px;
      line-height: 54px;
      background: rgba(2, 210, 142, 0.9);
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      margin-left: 427px;
      margin-top: 20px;
      text-align: center;
      font-size: 20px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #13161b;
      cursor: pointer;
    }
  }
  .BlockListws {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    // height: 1000px !important;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    overflow: auto;
    .box {
      width: 458px;
      height: 202px;
      background: #13161b;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      position: absolute;
      // border: 1px solid red;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .tit1 {
        margin-top: 36px;
        text-align: center;
        height: 26px;
        font-size: 22px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 26px;
      }
      .tit2 {
        margin-top: 10px;
        height: 16px;
        font-size: 14px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 16px;
        text-align: center;
      }
      .button {
        width: 134px;
        height: 44px;
        line-height: 44px;
        background: rgba(2, 210, 142, 0.9);
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        text-align: center;
        margin-top: 36px;
        margin-left: 158px;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #13161b;
        cursor: pointer;
      }
    }
  }
}
</style>
